import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { IVendorAssessmentType } from 'models/vendorAssessmentType';
import { IVendorAssessmentDefinition } from 'models/vendorAssessmentDefinition';


interface Props {
  open: boolean;
  loading: boolean;
  vendorAssessmentTypes: IVendorAssessmentType[];
  vendorAssessmentDefinitions: IVendorAssessmentDefinition[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const AddWorkshopAssessment: React.FC<Props> = ({ open, loading, vendorAssessmentTypes, vendorAssessmentDefinitions, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let assessmentDefinitionOptions = vendorAssessmentDefinitions.map((definition) => {
    const label = definition.internalId 
      ? `${definition.title} (${definition.internalId})`
      : definition.title;
    return { value: definition.id, label: label };
  });
  let assessmentTypesOptions = vendorAssessmentTypes.map((type) => {
    return { value: type.id, label: type.name };
  });
  let basicFields: IFormField[] = [
    {
      name: 'assessmentDefinitionId',
      label: t('T_assessment'),
      type: InputTypes.SELECT,
      placeholder: t('T_select_assessment'),
      internalLabel: true,
      required: true,
      options: assessmentDefinitionOptions
    },
    {
      name: 'typeId',
      label: t('T_type'),
      type: InputTypes.SELECT,
      placeholder: t('T_select_type'),
      internalLabel: true,
      required: true,
      options: assessmentTypesOptions
    },
    {
      name: 'timeToComplete',
      label: t('T_time_to_complete'),
      type: InputTypes.NUMBER,
      placeholder: t('T_time_to_complete'),
      internalLabel: true,
      required: true
    },
    {
      name: 'active',
      label: t('T_active'),
      type: InputTypes.SWITCH,
      internalLabel: true,
      required: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_workshop_assessment')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddWorkshopAssessment;
